<template>
    <div class="row" v-if="isRendered">
        <div class="col-12">
            <div class="row mb-5">
                <div class="col-12">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <p class="text-secondary mb-3">
                                <span class="icon icon-glyphicons-basic-paragraph-left"></span>
                                Text Response Inquiry
                            </p>
                            <h5 class="mb-1">{{ panel.reporting_label }}</h5>
                            <p class="mb-0">
                                <router-link v-if="!disableEditorLinks" :to="nodeAuthorLink"
                                    >Screen {{ panel.node.number }} - {{ panel.node.title }}</router-link
                                >
                                <span v-else>{{ panel.node.number }} - {{ panel.node.title }}</span>
                            </p>
                        </div>
                        <div class="flex-grow-0">
                            <div class="flex-grow-0 flex-shrink-0">
                                <div class="mb-0">
                                    <form method="GET" action="/api/reports/text/export/">
                                        <input
                                            v-for="param in reportParams"
                                            :key="param"
                                            hidden
                                            style="display: none"
                                            :name="param"
                                            :value="reportQuery[param]"
                                        />
                                        <button class="btn btn-light btn-sm" type="submit">
                                            <span class="icon icon-lg icon-glyphicons-basic-square-download mr-2"></span
                                            >Export Data
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12">
                    <p class="h6 mb-3">
                        Text Responses
                        <span class="badge badge-gray ml-1"
                            >{{ textResponseReport.num_responders }} Total Responders</span
                        >
                    </p>
                </div>
                <div class="col-12 col-lg-12">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="response in textResponseReport.responses" :key="response.id">
                            <div class="border-left quote-border mb-4 mt-3">
                                <p class="mb-0 font-italic">
                                    {{ response.text }}
                                    <span v-if="response.is_edited_response" class="badge badge-tiny badge-gray ml-1">
                                        Edited
                                    </span>
                                </p>
                            </div>
                            <p class="mb-3" v-if="response.ai_gen_feedback.feedback">
                                <text-response-ai-feedback
                                    :panel="panel"
                                    :response="response"
                                ></text-response-ai-feedback>
                            </p>
                            <p class="mb-0 text-secondary small">
                                Submitted by
                                <span v-if="response.session.organization_member">
                                    <router-link :to="`/users/${response.session.organization_member.id}/`">
                                        {{ response.session.learner_identifier }}
                                    </router-link>
                                </span>
                                <span v-else>
                                    {{ response.session.learner_identifier || "[Anonymous Learner]" }}
                                </span>
                                <span> on {{ displayTimestamp(response.timestamp) }} </span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-4" v-show="textResponseReport.responses.length == 0">
                <div class="col-12">
                    <p class="text-secondary">There aren't any responses to this inquiry yet.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/axios.js"
import Utilities from "@/assets/js/utilities.js"
import TextResponseAiFeedback from "@/components/TextResponseAiFeedback"

export default {
    name: "TextResponseReport",
    components: {
        TextResponseAiFeedback,
    },
    props: {
        panelId: {
            type: Number,
            required: false,
        },
        libraryItemId: {
            type: String,
            required: false,
            default: null,
        },
        startDate: {
            type: String,
            required: false,
            default: null,
        },
        endDate: {
            type: String,
            required: false,
            default: null,
        },
        organizationId: {
            type: Number,
            required: false,
        },
        shareLinkId: {
            type: Number,
            required: false,
            default: null,
        },
        pageId: {
            type: Number,
            required: false,
            default: null,
        },
        includeShareLinks: {
            type: Boolean,
            required: false,
            default: true,
        },
        // When true, links to the case editor view are hidden.
        disableEditorLinks: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            panel: {
                node: {},
            },
            isRendered: false,
            textResponseReport: {
                responses: [],
            },
            reportParams: [
                "libraryItemId",
                "panelId",
                "organizationId",
                "startDate",
                "endDate",
                "shareLinkId",
                "pageId",
                "includeShareLinks",
            ],
        }
    },
    computed: {
        nodeAuthorLink() {
            return `/library/${this.panel.node.case_id}/nodes/${this.panel.node.id}/`
        },
        reportQuery() {
            let query = {
                libraryItemId: this.libraryItemId,
                panelId: this.panelId,
                startDate: this.startDate,
                endDate: this.endDate,
                organizationId: this.organizationId,
                pageId: this.pageId,
                shareLinkId: this.shareLinkId,
                includeShareLinks: this.includeShareLinks,
            }
            return query
        },
    },
    methods: {
        refresh() {
            let vm = this
            this.$store.dispatch("addLoad")
            http.get("/api/reports/text/", {
                params: this.reportQuery,
            })
                .then(function (response) {
                    vm.panel = response.data.panel
                    vm.textResponseReport = response.data
                    vm.isRendered = true
                })
                .finally(function () {
                    vm.$store.dispatch("removeLoad")
                })
        },
        displayTimestamp(dateStr) {
            if (!dateStr) {
                return ""
            }
            return Utilities.formatDateTime(dateStr)
        },
    },
}
</script>